import React from "react";
import SecurityQuestions from "./SecurityQuestions";
import { useTranslation } from "react-i18next";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";

interface IProps {
    displayData: any;
    registrationState: any;
    setRegistrationState: any;
    manage: any;
}

const Security = ({ displayData, registrationState, setRegistrationState, manage }: IProps) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    return (
        <div className="row" id="content">
            <div className="col-xs">
                <div className="box box-has-shadow offset-padding">
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-icon" aria-hidden="true">
                                <RenderIcons iconName="key" />
                            </div>
                            <div className="box-title-text">
                                <h2 className="box-title">{tLang("registration.security.title")}</h2>
                            </div>
                        </div>
                    </div>
                    <SecurityQuestions
                        registrationState={registrationState}
                        setRegistrationState={setRegistrationState}
                        manageState={manage}
                        displayData={displayData}
                    />
                </div>
            </div>
        </div>
    );
};

export default Security;
